<template>
  <div class="container-fluid">
    <div class="mt-3 mb1 px-4">
      <b-button :to="{ name: 'AdminHome' }" variant="success">
        Volver a home de admin
      </b-button>
    </div>
    <b-row class="mt-5 mb-1 px-4">
      <b-col class="text-center text-white" cols="12">
        <h1>Regalos</h1>
        <p class="mt-2">Solicitudes de regalo de experiencia y estado de pago</p>
      </b-col>
    </b-row>
    <b-row class="p-4">
      <b-col cols="12">
        <b-row>
          <b-col cols="12" class="my-2">
            <b-form-group
              label="Filtrar por palabra"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="md"
              label-for="filterInput"
              class="mb-1 text-white"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  class="w-100"
                  placeholder="Ingresa un termino (ID, nombre, correo, experiencia)..."
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center text-white py-4">
          <b-spinner small></b-spinner>
          Cargando regalos...
        </div>
        <b-table
          v-else
          show-empty
          :fields="regalosTitulos"
          :items="regalosTabla"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          empty-text="Aun no existen solicitudes de regalo."
          empty-filtered-text="Sin registros que coincidan con la busqueda..."
          head-variant="dark"
          table-variant="light"
          striped
          hover
          @filtered="onFiltered"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(estadoPago)="data">
            <b-badge :variant="getBadgeVariant(data.item.estadoPago)">
              {{ data.item.estadoPago }}
            </b-badge>
          </template>
          <template v-slot:cell(acciones)="data">
            <div class="container-fluid">
              <b-row>
                <b-col v-if="!isPagado(data.item.estadoPago)" class="text-center">
                  <b-icon
                    @click="confirmarPagoManual(data.item)"
                    class="iconHover"
                    icon="check-circle-fill"
                    variant="success"
                    font-scale="1.5"
                    title="Marcar como pagado manualmente (transferencia)"
                  />
                </b-col>
                <b-col class="text-center">
                  <b-icon
                    class="iconHover"
                    icon="card-text"
                    variant="primary"
                    font-scale="1.5"
                    @click="data.toggleDetails"
                    title="Ver/ocultar detalles"
                  />
                </b-col>
              </b-row>
            </div>
          </template>
          <template v-slot:row-details="data">
            <b-card class="ml-2 pl-4 pt-2">
              <ul style="line-height: 2">
                <li>
                  <strong>ID Regalo:</strong> {{ data.item.idUnico }}
                </li>
                <li>
                  <strong>Comprador:</strong> {{ data.item.nombreCompleto }}
                </li>
                <li>
                  <strong>Email comprador:</strong> {{ data.item.email }}
                </li>
                <li>
                  <strong>Telefono:</strong> {{ data.item.telefono }}
                </li>
                <li>
                  <strong>Pais / Ciudad:</strong> {{ data.item.pais }} / {{ data.item.ciudad }}
                </li>
                <li>
                  <strong>Experiencia regalada:</strong> {{ data.item.experiencia }}
                </li>
                <li>
                  <strong>Monto:</strong> {{ data.item.monto }}
                </li>
                <li>
                  <strong>Fecha de solicitud:</strong> {{ data.item.fecha }}
                </li>
                <li>
                  <strong>Estado de pago:</strong> {{ data.item.estadoPago }}
                </li>
                <li v-if="data.item.fechaPago">
                  <strong>Fecha de pago:</strong> {{ data.item.fechaPago }}
                </li>
                <li>
                  <strong>Destinatario:</strong> {{ data.item.nombreDestinatario || '(no especificado)' }}
                </li>
                <li>
                  <strong>Mensaje del regalo:</strong> {{ data.item.mensaje || '(sin mensaje)' }}
                </li>
                <li v-if="data.item.notificadoCorreoPago">
                  <strong>Correos de pago enviados:</strong> Si
                </li>
              </ul>
              <div v-if="!isPagado(data.item.estadoPago)" class="mt-2">
                <b-button variant="success" size="sm" @click="confirmarPagoManual(data.item)">
                  <b-icon icon="check-circle-fill" /> Marcar como pagado (transferencia)
                </b-button>
              </div>
            </b-card>
          </template>
        </b-table>
        <b-row>
          <b-col cols="12" class="my-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              per-page="7"
              align="fill"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { db } from "../../firebase.service";
import { notifyBrevo } from "@/utils/notify";
import moment from "moment";

export default {
  name: "Regalos",
  metaInfo: {
    title: "Regalos"
  },
  data() {
    return {
      regalos: [],
      loading: true,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 7,
      // Ordenamos por idUnico desc por defecto. Como los IDs tienen formato R-{timestamp}
      // (timestamp en ms), el orden lexicografico desc coincide con "ultimo regalo arriba".
      sortBy: "idUnico",
      sortDesc: true,
      sortDirection: "desc",
      regalosTitulos: [
        { key: "index", label: "N°" },
        { key: "fecha", label: "Fecha solicitud", sortable: true, class: "text-center" },
        { key: "idUnico", label: "ID Regalo", sortable: true, class: "text-center" },
        { key: "experiencia", label: "Experiencia", sortable: true, class: "text-center" },
        { key: "nombreCompleto", label: "Comprador", sortable: true, class: "text-center" },
        { key: "email", label: "Correo", sortable: true, class: "text-center" },
        { key: "monto", label: "Monto", class: "text-center" },
        { key: "estadoPago", label: "Pago", sortable: true, class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" }
      ]
    };
  },
  created() {
    this.cargarRegalos();
  },
  computed: {
    regalosTabla() {
      return (this.regalos || []).map(r => {
        const exp = r.experiencia || {};
        const paquete = r.paquete || {};
        const nombre = (r.nombre || "").trim();
        const apellido = (r.apellido || "").trim();
        const monto = paquete.price ? "$ " + String(paquete.price).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " CLP" : "-";
        return {
          id: r.id,
          idUnico: r.idUnico || "-",
          fecha: r.fecha || "-",
          experiencia: exp.titulo || "-",
          nombreCompleto: (nombre + " " + apellido).trim() || "(sin nombre)",
          email: r.email || "-",
          telefono: r.telefono || "-",
          pais: r.pais || "-",
          ciudad: r.ciudad || "-",
          monto: monto,
          montoNumerico: paquete.price || "",
          estadoPago: (r.paymentStatus || "Pendiente").toString(),
          fechaPago: r.fechaPago || null,
          nombreDestinatario: r.nombreDestinatario || "",
          mensaje: r.mensaje || "",
          notificadoCorreoPago: r.notificadoCorreoPago || false,
          nombre: nombre,
          apellido: apellido,
          // Referencia al objeto crudo de Firestore para usarlo al actualizar
          _raw: r
        };
      });
    }
  },
  methods: {
    cargarRegalos() {
      this.loading = true;
      this.unsubscribe = db
        .collection("regalos")
        .onSnapshot(
          snapshot => {
            const arr = [];
            snapshot.forEach(doc => {
              arr.push({ id: doc.id, ...doc.data() });
            });
            this.regalos = arr;
            this.totalRows = arr.length;
            this.loading = false;
          },
          err => {
            console.log("Error al cargar regalos:", err);
            this.loading = false;
          }
        );
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isPagado(estado) {
      const s = (estado || "").toString().toUpperCase().trim();
      return s === "PAGADO" || s === "PAID" || s === "PAGO_EXITOSO" || s === "PAGO EXITOSO";
    },
    getBadgeVariant(estadoPago) {
      if (this.isPagado(estadoPago)) return "success";
      const s = (estadoPago || "").toString().toUpperCase().trim();
      if (s === "PENDIENTE") return "warning";
      return "secondary";
    },
    async confirmarPagoManual(item) {
      const ok = window.confirm(
        "¿Confirmar que el regalo " + item.idUnico + " (" + item.nombreCompleto + ") fue pagado via transferencia?\n\n" +
        "Esto actualizara el estado a PAGADO y enviara los correos de confirmacion a Surreal y al cliente."
      );
      if (!ok) return;
      try {
        // 1) Actualizar Firestore
        await db.collection("regalos").doc(item.id).update({
          paymentStatus: "PAGADO",
          notificadoCorreoPago: true,
          fechaPago: moment().format(),
          pagoManual: true
        });
        // 2) Enviar correos via EmailJS (mismo flujo que callback automatico de TBK)
        await this.enviarCorreoSurrealPagoExitoso(item);
        await this.enviarCorreoClientePagoExitoso(item);
        this.$bvToast && this.$bvToast.toast(
          "Regalo " + item.idUnico + " marcado como pagado. Correos enviados.",
          {
            title: "Pago manual confirmado",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-center"
          }
        );
      } catch (error) {
        console.log("Error al marcar pago manual:", error);
        this.$bvToast && this.$bvToast.toast(
          "Error al marcar el pago. Revisa la consola.",
          {
            title: "Error",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-center"
          }
        );
      }
    },
    async enviarCorreoSurrealPagoExitoso(item) {
      const templateID = "temp_pago_regalo_exitoso";
      const templateParams = {
        id_regalo: item.idUnico,
        fechaActual_regalo: item.fecha || "",
        email_regalo: item.email,
        experiencia_regalo: item.experiencia || "Experiencia",
        nombre_regalo: item.nombreCompleto || "",
        total: item.montoNumerico || ""
      };
      try {
        await notifyBrevo(templateID, templateParams);
      } catch (error) {
        console.log("Error enviando correo a Surreal por pago manual:", error);
      }
    },
    async enviarCorreoClientePagoExitoso(item) {
      const templateID = "pago_regalo_exitoso";
      const templateParams = {
        user_name: item.nombre || "",
        user_mail: item.email,
        experience_name: item.experiencia || "Experiencia",
        regalo_ID: item.idUnico,
        lang: (item._raw && item._raw.idioma) || "español",
        total: item.montoNumerico || ""
      };
      try {
        await notifyBrevo(templateID, templateParams);
      } catch (error) {
        console.log("Error enviando correo a cliente por pago manual:", error);
      }
    }
  },
  beforeDestroy() {
    if (typeof this.unsubscribe === "function") {
      this.unsubscribe();
    }
  }
};
</script>

<style></style>
